import { AiFillCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../../context/admin";
import Modal from "../../../common/Modal";
import AdminService from "../../../../services/admin.service";

// used for traspax
export default function ConfirmDeletePayment() {
    const { confirmDeletePaymentId, setConfirmDeletePaymentId } = useAdmin()

    async function onDelete(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        try {
            await AdminService.deletePayment(confirmDeletePaymentId!)
            window.location.reload()
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <Modal onSubmit={onDelete}>
            <h1>Confirm delete payment</h1>
            <p>Are you sure you want to delete this payment?</p>
            <div className="actions" 
            style={{ margin: '15px 0'}}
            >
                <button className="delete">Delete</button>
            </div>
            <div className="close" onClick={() => setConfirmDeletePaymentId(undefined)}>
                <AiFillCloseCircle />
            </div>
        </Modal>
    )
}